/** @jsxImportSource @emotion/react */

import { SubGameResponse } from "api/game/type";
import SwiperBg from "assets/Desktop/images/homepage/swiper-bg.png";
import { GameTypeEnum } from "enums/game";
import { useAppDispatch } from "hooks/app-hook";
import { useNavigate } from "react-router-dom";
import { updateGameProviderCode } from "store/game";
import { getGameList } from "store/game/game.thunk";

import { TypeGameSwiper } from "./list-game";
import { GamesSwiperStyle } from "./style.index";

const GameSwiper = (props: TypeGameSwiper) => {
  const { image, id, link } = props;

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const getGameLobby = async (
    idGame: string,
    path: string,
    providerCode?: string
  ) => {
    try {
      const response = await dispatch(getGameList(idGame));
      const payload = response.payload as SubGameResponse;
      const data = payload?.data;

      if (Array.isArray(data) && data.length > 0) {
        const code = providerCode ? providerCode : data[0]?.provider_code;
        if (code) {
          dispatch(updateGameProviderCode(code));
          navigate(`${path}/${code}`);
          return;
        }
      }
    } catch (error) {
      console.error(error);
    }

    navigate(path);
  };

  const handleRedirectSubGame = (
    idGame: string,
    path: string,
    providerCode?: string
  ) => {
    if (
      idGame.includes(GameTypeEnum.Slot) ||
      idGame.includes(GameTypeEnum.Fishing) ||
      idGame.includes(GameTypeEnum.BoardGame)
    ) {
      return getGameLobby(idGame, path, providerCode);
    }

    navigate(path);
  };

  return (
    <div
      css={GamesSwiperStyle.index}
      onClick={() => handleRedirectSubGame(id, link)}
    >
      <div css={GamesSwiperStyle.shadow}>
        <img src={SwiperBg} alt="" />
      </div>
      <div css={GamesSwiperStyle.img}>
        <img src={image} alt="" />
      </div>
    </div>
  );
};

export default GameSwiper;
